/** 40px, the proto's bar height: a 32px round control inside 4px of padding. */
export const HEADER_PILL_HEIGHT = 10;

/** Room a panel leaves above the bottom row of bars: one bar and the inset under it. */
export const BOTTOM_BAR_ROOM =
  "calc(var(--chakra-sizes-10) + var(--chakra-space-4))";

/** The floating bars over the canvas, shared by the header's clusters and each editor's own controls. */
export const headerPillStyle = {
  height: HEADER_PILL_HEIGHT,
  bg: "white",
  borderRadius: "full",
  // Floating elements take their edge from a shadow, not a border.
  boxShadow: "sm",
  px: 1,
};

/** A bar's menu trigger shows its open menu with the pressed fill alone: htui's open-menu ring would show on a mouse click too, where a focus ring belongs only to keyboard focus. */
export const pillMenuTriggerStyle = {
  _expanded: {
    boxShadow: "none",
    // The open-menu rule outranks htui's focus ring, so keyboard focus restates it.
    _focusVisible: { boxShadow: "outline" },
  },
} as const;
